module.exports = __webpack_public_path__ + "static/media/image-12.6a2003e9.PNG";